<div class="card overflow-auto">
  <div class="bg-app-bar px-6 h-16 border-b sticky left-0 flex items-center">
    <h2 class="title my-0 ltr:pr-4 rtl:pl-4 ltr:mr-4 rtl:ml-4 ltr:border-r rtl:border-l hidden sm:block flex-none">
      <span> Program Űcreti Alacakları </span>
    </h2>

    <button (click)="loadData()" class="ml-4 flex-none" mat-icon-button matTooltip="Yenile" type="button">
      <mat-icon svgIcon="mat:refresh"></mat-icon>
    </button>

    <span class="flex-1"></span>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate" color="primary"></mat-progress-bar>

  <table *ngIf="!loading && data">
    <thead>
      <tr>
        <th>Ofis</th>
        <th>Alacak</th>
        <th>Tahsilat</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of data">
        <tr (click)="item.expanded = !item.expanded">
          <td>
            #{{ item.enrollmentId }} {{ item.enrollmentName }} |
            {{ item.currencyId | entity: 'Currency' | async }}
          </td>
          <td>
            <p class="text-secondary m-0">
              <span class="font-medium text-red"> {{ item.totalCredit | currency: item.currencyId | async }} </span>
            </p>
          </td>
          <td>
            <p class="text-secondary m-0">
              <span class="font-medium text-green"> {{ item.totalReceipt | currency: item.currencyId | async }} </span>
            </p>
          </td>
        </tr>
        <tr *ngIf="item.expanded">
          <td colspan="3">
            <table>
              <thead>
                <tr>
                  <th>Tarih / No</th>
                  <th>Tip</th>
                  <th>Miktar</th>
                  <th>Not</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let transaction of item.transactions">
                  <td class="text-center">
                    #{{ transaction.id }} <br />
                    {{ transaction.date | date: 'dd-MM-yyyy HH:mm' : '+300' }}
                  </td>
                  <td>
                    <span *ngIf="transaction.type == 1" class="text-red">Alacak</span>
                    <span *ngIf="transaction.type == 2" class="text-green">Tahsilat</span>
                  </td>
                  <td>{{ transaction.amount | currency: transaction.currencyId | async }}</td>
                  <td>{{ transaction.note }}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>

  <mat-paginator
    [pageSize]="pageSize"
    [pageSizeOptions]="[10, 20, 50]"
    (page)="pageChanged($event)"
    class="sticky left-0">
  </mat-paginator>
</div>
